import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LoadingIndicator } from 'web-ui-kit/loading';
import cookie from 'js-cookie';

import warehouse from 'services/warehouse';
import { navigateToEmailVerified, navigateTo404 } from 'services/routing';
import { requestUserData } from 'redux/User';

class EmailVerification extends Component {
  componentDidMount () {
    const { match } = this.props;
    const token = match.params.token;

    warehouse.verifyEmail({ token }).then(data => {
      Promise.resolve(cookie.set('jwtToken', data.jwtToken, { expires: 30 }));
      this.props.updateAuthData();
      navigateToEmailVerified();
    }).catch(() => {
      navigateTo404();
    });
  }

  render () {
    return <LoadingIndicator isLoading pastDelay position='fixed' />;
  }
}

const mapDispatchToProps = dispatch => ({
  updateAuthData () {
    dispatch(requestUserData());
  }
});

export default connect(null, mapDispatchToProps)(EmailVerification);
